import { Component, OnInit, HostListener } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  title = ' ارزهای برتر بازار | دنیای رمزارز نااریب';
  showPopover: boolean = false;
  showPopover2: boolean = false;
  showPopover3: boolean = false;
  loader: boolean = true;
  pageNotParsed = Number(this.activateRoute.snapshot.paramMap.get('page'));
  page =  (this.pageNotParsed > 1 && 128 > this.pageNotParsed) ? this.pageNotParsed : 1;
  sortOrder: string = 'market_cap_desc';

  results;
  dollar;

  public innerWidth: any;

  headers = { 'content-type': 'application/json'};
  body = JSON.stringify({
    srcCurrency: "usdt", dstCurrency: "irr",
  });

  constructor(
    private http: HttpClient, 
    private activateRoute: ActivatedRoute,
    private titleService: Title
  ){ 

    this.titleService.setTitle(this.title);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  ngOnInit() {
    // Called after the constructor and called  after the first ngOnChanges() 

    this.innerWidth = window.innerWidth;

    // alert(this.page);

    setTimeout(() => {
      this.loader = false;
    }, 1000)

    this.http.get<any>(`https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=${this.sortOrder}&per_page=100&page=${this.page}&sparkline=true&price_change_percentage=7d`).subscribe(data => {
      this.results = data;
    });

    this.http.post<any>('https://api.nobitex.ir/market/stats', this.body, {'headers':this.headers}).subscribe(data => {
      this.dollar = data.stats['usdt-irr']['latest'];
    });

    setInterval(() => {

      this.http.get<any>(`https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=${this.sortOrder}&per_page=100&page=${this.page}&sparkline=true&price_change_percentage=7d`).subscribe(data => {
        this.results = data;
      })

      this.http.post<any>('https://api.nobitex.ir/market/stats', this.body, {'headers':this.headers}).subscribe(data => {
        this.dollar = data.stats['usdt-irr']['latest'];
      });

    }, 10000); 
      
  }


  goToCoin(sym) {
    document.location.href = 'https://naorib.ir/marketcap2/coin/' + sym ;
  }

  goTopage() {
    //this.results = null;
    this.page = Number(this.activateRoute.snapshot.paramMap.get('page'));

  }


}
